import {State} from "../state";
import {createSelector, MemoizedSelector} from "@ngrx/store";
import {selectBpmnModelerState} from "./bpmn-modeler-state.selector";
import {ClipboardName} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {Clipboard} from "@ispm-client/modules/bpmn-modeler/models/clipboard";

const getClipboard = (state: State): any => state.nodesCreationInfo[ClipboardName];

export const selectClipboard: MemoizedSelector<object, Clipboard> = createSelector(selectBpmnModelerState, getClipboard);
